var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQi4MLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 793.70001,
    height: 793.70667,
    viewBox: "0 0 793.70001 793.70667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,595.28 H 595.275 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,793.70667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.4097,228.7783)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#d2272a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 6.399 l 12.497,91.607 -4.485,9.009 z M 146.468,141.914 83.75,14.069 20.338,142.025 18.882,131.758 83.618,1.363 143.379,122.238 160.268,0 h 6.635 z m -178.541,0.111 -75.181,-106.884 h 47.769 v 10.202 h -28.107 l 45.322,64.458 V 0 h 10.197 v 35.141 h 17.105 l 1.462,10.202 H -32.073 Z M -135.342,0 h 13.722 v 101.383 h -13.722 z m -40.747,30.289 -21.951,21.348 h -24.704 l 24.973,-24.272 c -9.919,-8.969 -23.058,-14.45 -37.522,-14.45 -30.879,0 -55.937,25.045 -55.937,55.939 0,30.909 25.058,55.961 55.937,55.961 30.913,0 55.965,-25.052 55.965,-55.961 0,-3.567 -0.354,-7.042 -0.983,-10.438 l 14.096,-13.703 c 2.635,7.566 4.104,15.683 4.104,24.141 0,40.416 -32.782,73.171 -73.182,73.171 -40.387,0 -73.155,-32.755 -73.155,-73.171 0,-40.4 32.768,-73.156 73.155,-73.156 19.289,0 36.82,7.475 49.881,19.656 L -169.612,0 h 24.705 l -29.36,28.52 z m 47.598,111.736 c -6.739,0 -12.194,-5.468 -12.194,-12.194 0,-6.734 5.455,-12.202 12.194,-12.202 6.754,0 12.208,5.468 12.208,12.202 0,6.726 -5.454,12.194 -12.208,12.194"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQi4MLogo);
export default __webpack_public_path__ + "static/media/Qi4M_Logo.1dd41204bcc998ca3ab21a3745e09fb3.svg";
export { ForwardRef as ReactComponent };